/**
 * Labstep
 *
 * @module screens/PurchaseOrder/Show
 * @desc PurchaseOrder Show Screen
 */

import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { PurchaseOrder } from 'labstep-web/models/purchase-order.model';
import MasterShow from 'labstep-web/screens/Master/Show';
import { PurchaseOrderShowCenter as Center } from 'labstep-web/screens/PurchaseOrder/Show/Center';
import { ScreensPurchaseOrderShowRight as Right } from 'labstep-web/screens/PurchaseOrder/Show/Right';
import type React from 'react';
import type {
  IPurchaseOrderShowScreenContainerProps,
  IPurchaseOrderShowScreenProps,
} from './types';

export const PurchaseOrderShowScreen: React.FC<
  IPurchaseOrderShowScreenProps
> = ({ purchaseOrder }) => (
  <>
    <DocumentHead title={purchaseOrder.name} />
    <MasterShow
      entity={purchaseOrder}
      center={<Center purchaseOrder={purchaseOrder} />}
      right={<Right purchaseOrder={purchaseOrder} />}
    />
  </>
);

export const PurchaseOrderShowScreenContainer: React.FC<
  IPurchaseOrderShowScreenContainerProps
> = ({ match }) => (
  <ReadOnMountHOC
    type="entities"
    entityName={PurchaseOrder.entityName}
    params={{
      get_single: 1,
      is_deleted: 'both',
      id: match.params.id,
    }}
    loading={{ loader: 'show', cached: true }}
    children={({ entity }) => (
      <PurchaseOrderShowScreen purchaseOrder={entity} />
    )}
  />
);
